import { Application, Controller } from "@hotwired/stimulus";

// チェックされた checkbox の件数と data-amount 合計を、それぞれ
// selectedCount / selectedTotal target に表示する。
// data-action="change->form-checkbox-sum#update" を各 checkbox に、
// 全選択/選択クリアボタンには既存の form-checkbox の action とチェーンして
// "click->form-checkbox#selectAll click->form-checkbox-sum#update" のように
// 呼び出すことで、ボタン操作時も件数/合計が同期する。
class FormCheckboxSumController extends Controller {
  static targets = ['checkbox', 'selectedCount', 'selectedTotal']

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    const sum = checked.reduce((acc, cb) => acc + Number(cb.dataset.amount || 0), 0)
    this.selectedCountTarget.textContent = count.toLocaleString('ja-JP')
    this.selectedTotalTarget.textContent = `¥${sum.toLocaleString('ja-JP')}`
  }

  // ソート時にチェック状態を維持するため、リンク href に selected_project_ids[] を付与する。
  // preventDefault せずに href のみ書き換えるので、リンクは Turbo Frame に処理が委譲され
  // フレーム部分 (プロジェクト一覧カード) のみが差し替わる。
  // サーバ側で params[:selected_project_ids] を読み取って @selected_project_ids に反映される。
  preserveSelection(event) {
    const link = event.currentTarget
    const url = new URL(link.href)
    url.searchParams.delete('selected_project_ids[]')
    this.checkboxTargets
      .filter(cb => cb.checked)
      .forEach(cb => url.searchParams.append('selected_project_ids[]', cb.value))
    link.href = url.toString()
  }
}

// Registered in admin.js
export { FormCheckboxSumController };
